import React, {Component} from 'react';
import {connect} from 'react-redux';


class AudioPlayer extends Component {
    componentDidMount() {
        const {audioPlayer} = this.props;
        const playbackRate = sessionStorage.getItem('playbackRate') || '1.0'
        if (playbackRate !== audioPlayer.playbackRate) {
            this.props.dispatch({
                type: 'AUDIO_SET_PLAYBACK_RATE',
                payload: playbackRate
            })

            const rate = parseInt(playbackRate)
            const au = document.getElementById('player_audio')
            au.defaultPlaybackRate = rate
            au.playbackRate = rate
        }
    }

    onCanPlay(e) {
        const {audioPlayer} = this.props;
        if (audioPlayer.audioState === 'playing') {
            return;
        }
        this.refs.audio.currentTime = 0;
        this.refs.audio.play();
        this.props.dispatch({
            type: 'AUDIO_PLAYING'
        });

    }

    onEnded(e) {
        this.props.dispatch({
            type: 'AUDIO_STOPPED'
        });
    }

    onTimeUpdate(e) {
        /* 避免安卓卡顿，把音频进度更新时间改为1秒，其他系统0.5秒 */
        let time = this.refs.audio.currentTime;
        if (window.systemType === 'android') {
            time = Math.floor(time);
        } else {
            time = Math.floor(time * 2) / 2.0;
        }
        if (this.props.audioPlayer.currentTime !== time) {
            this.props.dispatch({
                type: 'AUDIO_TIME_UPDATE',
                payload: {
                    time: time
                }
            });
        }
    }

    componentWillUpdate(props) {
        const {audioPlayer} = props;

        if (audioPlayer.audioState === 'load') {
            if (audioPlayer.dataUrl && audioPlayer.dataUrl.indexOf('wxLocalResource://') === 0) {
                if (!this.refs.audio.paused) {
                    this.refs.audio.pause();
                }
                window.wx.playVoice({
                    localId: audioPlayer.dataUrl
                });
                this.props.dispatch({
                    type: 'AUDIO_PLAYING'
                });
            } else {
                if (this.refs.audio.src === audioPlayer.dataUrl) {
                    this.refs.audio.play();
                    this.props.dispatch({
                        type: 'AUDIO_PLAYING'
                    });
                } else {
                    this.refs.audio.src = audioPlayer.dataUrl;
                    this.refs.audio.load();
                }
            }
        } else if (audioPlayer.audioState === 'stop') {
            if (audioPlayer.dataUrl && audioPlayer.dataUrl.indexOf('wxLocalResource://') === 0) {
                window.wx.stopVoice({
                    localId: audioPlayer.dataUrl
                });
            } else {
                this.refs.audio.pause();
            }
            this.props.dispatch({
                type: 'AUDIO_STOPPED'
            });
        } else if (audioPlayer.audioState === 'seek') {
            if (audioPlayer.dataUrl) {
                this.refs.audio.currentTime = audioPlayer.currentTime;
            }
            this.props.dispatch({
                type: 'AUDIO_PLAYING'
            });
        }
    }

    render() {
        return <audio id="player_audio" src="" ref="audio" preload="metadata"
                      onCanPlay={this.onCanPlay.bind(this)} onEnded={this.onEnded.bind(this)}
                      onTimeUpdate={this.onTimeUpdate.bind(this)}/>
    }
}

export default connect((state) => ({
    audioPlayer: state.audioPlayer
}))(AudioPlayer);




// WEBPACK FOOTER //
// ./src/components/AudioPlayer.js